import * as React from "react"
import { Divider, Grid } from "@mui/material"

import AdminBrandsNameTextField from "./BrandTextField"
import AdminBrandsColorPicker from "./Color"
import AdminBrandsCompanyAutocomplete from "./Company"
import AdminBrandsCustomerAutocomplete from "./Customer"
import AdminBrandsFormSwitch from "./Switch"
import AdminBrandsDisplayNameTextField from "./DisplayNameTextField"
import AdminBrandsKeywordTextField from "./KeywordTextField"
import AdminBrandsExcludedWordTextField from "./ExcludedWordTextField"
import AdminBrandsKeywordTester from "./KeywordTester"
import AdminBrandsCustomerAvailability from "./CustomerAvailability"

import { USER_ENV } from "@constants"
import { useUserApp } from "@hooks"


export default function AdminBrandsUpdateDrawerContent() {
    // Puig-only: retail's brands have no availability flags in this dashboard.
    const { userEnv } = useUserApp()
    const isPuig = userEnv === USER_ENV.PUIG

    return <Grid container spacing={3}>
        <Grid item xs={12}>
            <AdminBrandsNameTextField />
        </Grid>

        <Grid item xs={12}>
            <AdminBrandsDisplayNameTextField />
        </Grid>

        <Grid item xs={12}>
            <AdminBrandsCompanyAutocomplete />
        </Grid>

        <Grid item xs={12}>
            <AdminBrandsCustomerAutocomplete />
        </Grid>

        <Grid item xs={12}>
            <AdminBrandsKeywordTextField />
        </Grid>

        <Grid item xs={12}>
            <AdminBrandsExcludedWordTextField />
        </Grid>

        <Grid item xs={12}>
            <AdminBrandsColorPicker />
        </Grid>

        <Grid item xs={6}>
            <AdminBrandsFormSwitch label="Validated" field="validated" />
        </Grid>

        <Grid item xs={6}>
            <AdminBrandsFormSwitch label="Whole Word" field="wholeWord" />
        </Grid>

        {isPuig && <Grid item xs={12}>
            <AdminBrandsCustomerAvailability />
        </Grid>}

        <Grid item xs={12}>
            <Divider />
        </Grid>

        <Grid item xs={12}>
            <AdminBrandsKeywordTester />
        </Grid>
    </Grid>
}
